/**
 * PrefetchLink — a react-router Link that preloads the target route's code (and
 * optionally its data) on hover/focus, so the click feels instant.
 *
 * Pass the lazy route component as `preload` (a component created by
 * lazyWithPreload). Optionally pass `onPreload` to also warm RTK Query data.
 */
import { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';

export function PrefetchLink({ to, preload, onPreload, children, ...rest }) {
  const done = useRef(false);

  const warm = useCallback(() => {
    if (done.current) return;
    done.current = true;
    preload?.preload?.();
    onPreload?.();
  }, [preload, onPreload]);

  return (
    <Link to={to} onMouseEnter={warm} onFocus={warm} onTouchStart={warm} {...rest}>
      {children}
    </Link>
  );
}

export default PrefetchLink;
